import React, { useEffect } from "react";
import Table from "./Table";
import { useDispatch } from "react-redux";
import { getSubscribers } from "store/actions";
const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSubscribers());
  }, [dispatch]);

  return (
    <>
      <div className="users-wrap">
        <Table />
      </div>
    </>
  );
};

export default Index;
